import { createMuiTheme } from '@material-ui/core'

const theme = createMuiTheme({
    palette: {
        primary: {
            // 緑色
            main: '#f8ddb6',
            dark: '#689F38',
            light: '#DCEDC8'
        },
        text: {
            // ちょっと薄い黒
            primary: '#4e4e4e',
            secondary: '#757575'
        },
        background: {
            default: 'white',
            paper: 'linear-gradient(45deg, #fda9bd 30%, #f6b795 90%)'
        }
    }
})

export default theme
